import React from 'react';
import { observer } from 'mobx-react';
import { Router } from '@reach/router';

import { lightGrey1Color } from 'js/config/style';

import PageComponent from 'js/components/pages/PageComponent';
import AppContent from 'js/components/AppContent';
import Backdrop from 'js/components/core/Backdrop';
import Constraint from 'js/components/Constraint';

import Grid from './Grid';
import LogoImage from './LogoImage';
import MenuContainer from './MenuContainer';
import MenuGrid from './MenuGrid';
import DashboardMenu from './DashboardMenu';
import Panel from './Panel';

import Dashboard from './Dashboard';
import Users from './Users';
import Items from './Items';
import Tokens from './Tokens';
import Orders from './Orders';
import Shipments from './Shipments';
import BankAccounts from './BankAccounts';
import UsedLinks from './UsedLinks';
import CreditCards from './CreditCards';
import Transactions from './Transactions';
import MsellerList from './MsellerList';

import { height } from './DashPanel/Header';
import { breakpoint } from './Grid';
const offset = `${parseInt(height) + 1.5}rem`;

@observer
export default class AdminDashboardPage extends PageComponent {
  pageName = 'AdminDashboardPage';
  pageColor = lightGrey1Color;
  pageWidth = breakpoint;

  loginRequired = true;
  rolesRequired = ['admin'];

  renderPage() {
    return (
      <AppContent padded>
        <Backdrop offset={offset}>
          <Constraint>
            <LogoImage src="/images/payondelivery-logo/logo.svg" />
          </Constraint>
        </Backdrop>

        <Constraint offset={offset}>
          <Grid>
            <MenuContainer>
              <MenuGrid>
                <DashboardMenu />
              </MenuGrid>
            </MenuContainer>

            <Panel>
              <Router>
                <Dashboard path="/" />
                <Users path="users/*" />
                <Items path="items/*" />
                <Tokens path="tokens/*" />
                <Orders path="orders/*" />
                <Shipments path="shipments/*" />
                <BankAccounts path="bank_accounts/*" />
                <UsedLinks path="used_links/*" />
                <CreditCards path="credit_cards/*" />
                <Transactions path="transactions/*" />
                <MsellerList path="mseller_list/*" />
              </Router>
            </Panel>
          </Grid>
        </Constraint>
      </AppContent>
    );
  }
}
